<template>
    <v-autocomplete
        ref="province"
        v-model="province"
        :disabled="!to.filter.hosp || loading.to.region || loading.to.province"
        :readonly="!to.filter.hosp"
        :clearable="to.filter.hosp"
        color="teal"
        label="Province"
        :items="provinceItems"
        item-text="city_province"
        item-value="uid"
        return-object
        auto-select-first
        autocomplete="nope"
        :loading="loading.to.region || loading.to.province"
        @click:clear="handleClearProvince"
        @change="handleChangeProvince($event)"
    >
        <template #item="{ item }">
            <v-list-item-content>
                <v-list-item-title>{{ item.city_province }}</v-list-item-title>
                <v-list-item-subtitle>{{ item.city_region }}</v-list-item-subtitle>
            </v-list-item-content>
        </template>
    </v-autocomplete>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    props: ['to', 'member_model', 'loading'],
    data: () => ({
        province: null
    }),
    computed: {
        ...mapGetters(['getToProvinces', 'getToCities', 'getToRegions']),
        provinceItems() {
            return (this.getToProvinces || []).map(item => ({
                ...item,
                uid: `${item.city_region}${item.city_province}`
            }))
        }
    },
    watch: {
        getToProvinces() {
            this.loading.to.province = true
        },
        getToRegions() {
            this.loading.to.region = false
        },
        'to.province'(newVal) {
            if (!newVal) {
                this.province = null
                return
            }
            // keep the object model in sync if to.province is set from elsewhere (e.g. a city selection)
            this.province = this.provinceItems.find(i => i.city_province === newVal) || null
        }
    },
    methods: {
        ...mapActions(['toCities', 'toHospClin']),
        handleChangeProvince(item) {
            if (!item) {
                this.to.province = null
                return
            }
            this.to.province = item.city_province
            this.to.region = item.city_region
            this.to.city = ''
            this.to.facility = ''
            this.to.filter.doc = false
            this.to.specField = { sp_name: 'ALL', sp_desc: '' }
            this.to.hospClinDoctor = ''
            this.loading.to.city = true
            this.toCities({ REGION: item.city_region, PROVINCE: item.city_province })
            this.to.hospClinType = 'H'
            this.to.decking = ''
            this.loading.to.hospital = true
            this.toHospClin({
                REGION: item.city_region || '',
                PROVINCE: item.city_province || '',
                CITY: this.to.city ? this.to.city : '',
                TYPE: '',
                MEMBN: this.member_model.MEMB_N
            })
        },
        handleClearProvince() {
            this.to.province = null
            this.to.city = null
            this.province = null

            this.loading.to.city = true
            this.toCities({ REGION: this.to.region ? this.to.region : '', PROVINCE: '' })

            this.loading.to.hospital = true
            this.toHospClin({
                REGION: this.to.region ? this.to.region : '',
                PROVINCE: '',
                CITY: '',
                TYPE: '',
                MEMBN: this.member_model.MEMB_N
            })
        }
    }
}
</script>
